import { RAVideo } from "@/components/customs";
import { useEffect, useRef } from "react";
import styled from "styled-components";

export function HomeIntro({ video = "", snap = false, active }) {
	const videoRef = useRef(null);

	useEffect(() => {
		if (snap && active) {
			videoRef.current?.play();
		}
	}, [active]);
	return (
		<WrapperHomeIntro>
			{video && (
				<VideoContainer>
					<RAVideo
						ref={videoRef}
						forcePlay
						width="100vw"
						height="100vh"
						path={video || "https://royal-air.s3.us-west-2.amazonaws.com/pub/royal-air-final.mp4"}
					/>
				</VideoContainer>
			)}
		</WrapperHomeIntro>
	);
}

const WrapperHomeIntro = styled.div`
	width: 100vw;
	position: relative;
	/* margin: 40px 0; */
	height: 100%;
	scroll-snap-align: start;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #000;
`;

const VideoContainer = styled.div`
	height: 100vh;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
`;
